
import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";
import { array } from "yup";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/replenishment-b2b/invoice`;

export const invoiceService = {

    getInvoiceList: async function (invoiceNo: any, orderIds: any, customerCode: any, productCode: any, startDate: any, endDate: any) {
        return axios.get(`${GATEWAY_URL}/invoice_list`, {
            params: {
                InvoiceNo: invoiceNo,
                OrderIds: orderIds,
                CustomerCode: customerCode,
                ProductCode: productCode,
                StartDate: startDate,
                EndDate: endDate
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getVendorLookups: async function () {
        return axios.get(`${GATEWAY_URL}/invoice_customer_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    // getInvoiceLookups: async function () {
    //     return axios.get(`${GATEWAY_URL}/invoice_no_lookup`, {
    //     })
    //         .then((response) => {
    //             return response.data;
    //         });
    // },

    getProductLookups: async function () {
        return axios.get(`${GATEWAY_URL}/invoice_product_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getOrderNoLookups: async function () {
        return axios.get(`${GATEWAY_URL}/invoice_orders_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    getInvoice: async function (id: any) {
        return axios.get(`${GATEWAY_URL}/get_invoice`, {
            params: { Id: id }
        })
            .then((response) => {
                return response.data;
            });
    },

    getInvoiceDetailList: async function (InvoiceId: any) {
        return axios.get(`${GATEWAY_URL}/invoice_detail_list`, {
            params: { InvoiceId }
        })
            .then((response) => {
                return response.data;
            });
    },

    saveInvoice: async function (values: any) {
        return axios.put(`${GATEWAY_URL}/save_invoice`, values)
            .then((response) => {
                return response.data;
            });
    },

    getshipToLookups: async function (customerCode: string) {
        return axios.get(`${GATEWAY_URL}/invoice_location_lookup`, {
            params: {
                CustomerCode: customerCode,
            }
        })
            .then((response) => {
                return response.data;
            });
    },


    getOrdersLookups: async function (customerCode: string, locationCode: string) {
        return axios.get(`${GATEWAY_URL}/invoice_orderno_lookup`, {
            params: {
                CustomerCode: customerCode,
                LocationCode: locationCode,
            }
        })
            .then((response) => {
                return response.data;
            });
    },

    getTermsLookups: async function () {
        return axios.get(`${GATEWAY_URL}/invoice_terms_lookup`, {
        })
            .then((response) => {
                return response.data;
            });
    },

    orderLinesList: async function (orders: string[]) {
        return axios.post(`${GATEWAY_URL}/order_lines_list`,
            { orderLines: orders }
        )
            .then((response) => {
                return response.data;
            });
    },


    getDownloadInvoicePdf: async (invoiceId: number, fileName: string) => {
        try {
            const response = await axios.get(`${GATEWAY_URL}/download/` + invoiceId + `/` + fileName, {
                responseType: "blob",
                headers: {
                    Accept: ".pdf",
                },
            });
            const blob = new Blob([response.data], {
                type: ".pdf",
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Download error :', error);
        }
    }
}

